import type { JSONDocNode } from '@atlaskit/editor-json-transformer/types';
import { isJSONDocNode } from '@atlaskit/editor-json-transformer/main';

import { expValEquals } from '@confluence/feature-experiments';

import { parseContentNodesAdf, type ParseableContentNodes } from './parseContentNodesAdf.ts';
import { seedContentBodyAdfCache } from './getOrParseContentBodyAdf.ts';

export const warmContentBodyAdfCache = (
	contentNodes: ParseableContentNodes,
	onInvalidDocument: (contentId: string) => void,
): JSONDocNode | null => {
	const contentNode = contentNodes?.[0];
	const contentId = contentNode && 'id' in contentNode ? contentNode.id : undefined;
	const dynamicBody = contentNode?.body?.dynamic;
	const adfString = dynamicBody?.value;

	if (
		typeof contentId === 'string' &&
		contentId.length > 0 &&
		dynamicBody?.representation === 'atlas_doc_format' &&
		typeof adfString === 'string' &&
		adfString.length > 0 &&
		expValEquals('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)
	) {
		const parsedAdf = parseContentNodesAdf(contentNodes);

		if (isJSONDocNode(parsedAdf)) {
			seedContentBodyAdfCache(contentId, adfString, parsedAdf);
			return parsedAdf;
		}

		if (parsedAdf !== null) {
			onInvalidDocument(contentId);
		}
	}

	return null;
};
